<template>
    <div class="banner-card td-card shadow rounded">
        <!-- Image -->
        <div class="banner-card__image">
            <a class="banner-image" :href="displayBanner.websiteAddress" target="_blank" rel="nofollow">
                <v-lazy-image :key="displayBanner.imageId" :src="`/listings/banners/load-banner-image/${displayBanner.id}?v=${displayBanner.imageId}`" alt="Banner" width="480" height="60"></v-lazy-image>
            </a>
        </div>

        <!-- Content -->
        <div class="banner-card__content">
            <div class="meta td-flex td-text-mice td-text-subdued mb-4">
                <span>{{ displayBanner.type }}</span>
                <span><icon class="icon" type="solid" name="faCircle" aria-hidden="true"></icon></span>
                <span>{{ displayBanner.location }}</span>
                <span :class="displayBanner.statusClass">{{ displayBanner.status }}</span>
                <span v-if="showApproveBtn"><button class="td-btn slim approve-btn" @click="approveBanner($event)" title="Approve Banner">Approve</button></span>
            </div>

            <!-- Services -->
            <div class="banner-card__services" v-if="showAllServices">
                <span class="tag" v-for="(service, i) in displayBanner.services" :key="i">{{service}}</span>
                <span class="tag more" @click="toggleServices">Hide<icon class="icon ml-1" type="solid" name="faCaretUp" aria-hidden="true"></icon></span>
            </div>

            <div class="banner-card__services" v-else>
                <span class="tag" v-for="(service, i) in displayBanner.first5Services" :key="i">{{service}}</span>
                <span class="tag more" @click="toggleServices" v-if="displayBanner.services && displayBanner.services.length > servicesNumber">
                    Show more<icon class="icon ml-1" type="solid" name="faCaretDown" aria-hidden="true"></icon>
                </span>
            </div>

            <!-- Link -->
            <a :href="displayBanner.websiteAddress" class="td-link no-inderline td-text-mice">
                {{displayBanner.websiteAddress}}
            </a>
        </div>

        <!-- Footer -->
        <div class="banner-card__footer td-flex">
            <div v-if="viewDetails && isAdmin" class="td-flex">
                <a class="td-btn secondary-outlined slim" title="Vendor Analytics" :href="analyticsLink">View Analytics</a>
            </div>
            <div>
                <button v-if="showDetailsBtn" class="td-btn slim secondary-outlined icon-left" @click="openDetails($event, displayBanner.id)"><icon class="icon" type="solid" name="faEye" aria-hidden="true"></icon>View Details</button>
            </div>
            <div class="td-flex">
                <button :class="[{ disabled: !hasNoSubs }, 'td-btn', 'secondary', 'icon-only']" title="Edit Banner" @click="openEdit"><icon class="icon" type="solid" name="faPen" aria-hidden="true"></icon></button>
                <button v-if="isAdmin" :class="[{ disabled: !hasNoSubs }, 'td-btn', 'danger', 'icon-only']" title="Delete Banner" @click="openDelete(displayBanner.id)"> <icon class="icon" type="solid" name="faTrash" aria-hidden="true"></icon></button>
            </div>
        </div>
    </div>
    <div v-if="viewDetails && analytics.length > 0">
        <banner-analytics :banner="viewBanner" :analytics="analytics"></banner-analytics>
    </div>
    <edit-banner v-if="showEdit" :banner="banner" @close-edit="cancelEdit" @submit-edit="submitEdit" :is-admin="isAdmin" :all-services="allServices" :account-id="banner.accountId"></edit-banner>
    <!--delete (set status to inactive) -->
    <modal @close="closeDeleteModal" style="max-width:800px;height:auto" v-if="showDeleteModal" class="delete-modal">
        <template #header>
            <h4 class="td-h4">Delete Banner</h4>
        </template>
        <p class="my-2">Are you sure you want to remove the banner add?</p>
        <template #footer>
            <div class="actions">
                <button class="td-btn btn secondary-outlined" title="Cancel Delete" @click="closeDeleteModal">Cancel</button>
                <button class="danger td-btn" title="Delete Data Source" @click="confirmDelete">Delete</button>
            </div>
        </template>
    </modal>
</template>

<script>
    import script from './Banner';
    export default script;</script>

<style lang="less">
    @import "./Banner.less";
</style>